import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import DropdownStyled from '@/src/app/components/inputs/StyledInputs/DropdownStyled';
import {
  JCPhase,
  JCProjectedCost,
} from '@/src/app/Interfaces/Accounting/JobsContracts.interface';

type ProjectedPhaseCellProps = {
  row: JCProjectedCost;
  options?: JCPhase[];
  isLoading?: boolean;
  isError?: boolean;
  onChange: (phase?: string, description?: string) => void;
  showError?: boolean;
};

const ProjectedPhaseCell = ({
  row,
  options,
  isLoading,
  isError,
  onChange,
  showError,
}: ProjectedPhaseCellProps) => {
  const [editing, setEditing] = useState(false);
  const dropdownRef = useRef<Dropdown>(null);
  const hasError = showError && !row.Phase;

  useEffect(() => {
    if (!editing) {
      return;
    }

    const timer = setTimeout(() => {
      dropdownRef.current?.getFocusInput()?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [editing]);

  if (!editing && !hasError) {
    return (
      <div
        className="w-full text-center cursor-pointer white-space-nowrap overflow-hidden text-overflow-ellipsis totalColor"
        onClick={() => setEditing(true)}
      >
        {row.Phase || <i className="pi pi-pencil" />}
      </div>
    );
  }

  return (
    <DropdownStyled
      ref={dropdownRef}
      value={row.Phase || undefined}
      options={(options ?? []).map((phase) => ({
        label: `${phase.Phase} - ${phase.Description}`,
        ...phase,
      }))}
      labelField="label"
      valueField="Phase"
      placeholder={isError ? 'Failed to load phases!' : 'Select Phase'}
      isDisabled={isError}
      isLoading={isLoading}
      clearable={false}
      filter={true}
      resetFilterOnHide={true}
      showOnFocus
      error={hasError}
      onChange={(e) => {
        const selected = options?.find((phase) => phase.Phase === e.value);
        onChange(e.value, selected?.Description);
        setEditing(false);
      }}
      onHide={() => setEditing(false)}
    />
  );
};

export default ProjectedPhaseCell;
